import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClockMinuteHandmodule = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 13C11.4477 13 11 12.6418 11 12.2L11 5.8C11 5.35817 11.4477 5 12 5C12.5523 5 13 5.35817 13 5.8L13 12.2C13 12.6418 12.5523 13 12 13Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgClockMinuteHandmodule);
export default ForwardRef;
